export function getSVGRequiredPath(path: string) {
  return require(`../assets/svg/${path}.svg`).default;//eslint-disable-line
}
